import React, { Component } from 'react'
import { connect } from 'react-redux'

import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import BasicLgySelectField from 'app/components/util/lgy-select-field/BasicLgySelectField'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import UploadSuccessOrFailureMessage from '../summary/UploadSuccessOrFailureMessage'
import DocumentsUploadHistory from '../common/DocumentsUploadHistory'
import { getCookieValue } from 'app/actions/genericActionCreator'
import { fetchAssignmentCorrespondence } from '../../actions/fetchAssignmentCorrespondenceAction'
import { uploaderInit, removeFile, startUpload, setOption, destroy } from '../../actions/postAssignmentInfoAction'

class CorrespondenceHistory extends Component {
  constructor(props) {
    super(props)
    this.state = {
      docType: (this.props.assignmentDetails.appraisalCode === 'LAPP' || this.props.assignmentDetails.appraisalCode === 'IND') ? 'REPAIR_INSPECTION_REPORT' : 'OTHER',
      file: null,
      invalidMessage: [],
      responseMessage: null
    }
    this.fileInput = React.createRef()
  }

  componentDidMount() {
    const otherCorrespondencePluploadOptions = {
      handle: 'otherCorrespondenceUploader',
      runtimes: 'html5,html4',
      browse_button: this.fileInput.current,
      container: 'documents-upload',
      chunk_size: '2mb',
      max_file_size: '100mb',
      max_retries: '0',
      prevent_duplicates: false,
      multi_selection: false,
      max_file_count: 1,
      multiple_queues: false,
      url: `/lgyhub/api/appraiser-workspace/upload/correspondence`,
      headers: {
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      },
      filters: [
        { title: 'Allowed files', extensions: 'pdf,doc,docx,xlsx,xls,tif,tiff,gif,jpg,jpeg,png' }
      ],
      multipart_params: {}
    }

    this.props.uploaderInit(otherCorrespondencePluploadOptions)
  }

  componentDidUpdate(prevProps) {
    const { uploader, assignmentDetails, fetchAssignmentCorrespondence } = this.props
 
    if (uploader.files !== prevProps.uploader.files) {
      this.handleFileChanges(uploader.files)
    }
    if (uploader.error !== prevProps.uploader.error) {
      this.handleUploaderErrors(uploader)
    }
    if (uploader.responseMessage && uploader.responseMessage !== prevProps.uploader.responseMessage) {
      this.setState({ responseMessage: uploader.responseMessage })
      fetchAssignmentCorrespondence(assignmentDetails.id, assignmentDetails.lin)
    }
  }

  componentWillUnmount() {
    this.props.destroy('otherCorrespondenceUploader')
  }

  handleUploaderErrors = (uploader) => {
    if (uploader.error === 'File size error.') {
      this.setState(prevState => ({
        invalidMessage: [...prevState.invalidMessage, 'File uploads must be greater than 0 KB less than 9.5 MB.']
      }))
    }
    if (uploader.error === 'File extension error.') {
      this.setState(prevState => ({
        invalidMessage: [...prevState.invalidMessage,
          'Only .pdf, .doc, .docx, .xlsx, .xls, .tif, .tiff, .gif, .jpg, .jpeg, and .png file extensions are supported.']
      }))
    }
  }

  handleFileChanges = (files) => {
    if (files.length === 1 && files[0].status === 1) {
      this.setState({ file: files[0].name, invalidMessage: [] })
    } else if (files.length === 2) {
      this.setState({ file: files[1].name, invalidMessage: [] })
      this.props.removeFile(files[0].id, 'otherCorrespondenceUploader')
    }
  }

  handleChange = (event) => {
    event.preventDefault()
    this.setState({ invalidMessage: [] })
    this.setState({ docType: event.target.value })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    if (this.state.file) {
      this.props.setOption({
        option: 'multipart_params', value: {
          id: this.props.uploader.id+new Date(),
          documentType: this.state.docType,
          propertyAppraisalId: this.props.assignmentDetails.id,
          fileName: this.state.file
        }
      }, 'otherCorrespondenceUploader')
      this.props.startUpload('otherCorrespondenceUploader')
    }     
    this.handleReset()
  }

  handleReset = () => {
    this.setState({
      docType: (this.props.assignmentDetails.appraisalCode === 'LAPP' || this.props.assignmentDetails.appraisalCode === 'IND') ? 'REPAIR_INSPECTION_REPORT' : 'OTHER',
      file: null,
      invalidMessage: []
    })
  }

  render() {
    let appraisalTypeIsIndOrLap = this.props.assignmentDetails.appraisalCode === 'LAPP' || this.props.assignmentDetails.appraisalCode === 'IND'
    let { correspondence, uploader, eauthUrl, portalId } = this.props
    return (
      <div className='correspondence-history'>
        {this.state.responseMessage && <UploadSuccessOrFailureMessage responseMessage={this.state.responseMessage} documentTypeName='file' />}
        <LgySubsection className='documents-upload' header='Documents Uploads'>
          <form onSubmit={this.handleSubmit}>
            <fieldset id='documents-upload'>
              <BasicLgySelectField
                name='docType'
                id='docType'
                value={this.state.docType}
                label='Document Type'
                placeholder='none'
                required
                onChange={this.handleChange}
                dirty={this.state.file}
                error={this.state.invalidMessage.find(error => error.startsWith('docType')) ? 'Required' : undefined}>
                {appraisalTypeIsIndOrLap && <option value='REPAIR_INSPECTION_REPORT'>Repair Inspection Report</option>}
                {appraisalTypeIsIndOrLap && <option value='CONSTRUCTION_INSPECTION'>Post Construction Inspection Report</option>}
                {appraisalTypeIsIndOrLap && <option value='CONSTRUCTION_EXHIBITS'>Construction Exhibits</option>}
                <option value='OTHER'>Other</option>
              </BasicLgySelectField>
              <div className={this.state.invalidMessage.length > 0 ? 'usa-input-error' : ''}>
                <label htmlFor='file'>File to Upload</label>
                <button
                  id='file'
                  name='file'
                  type='button'
                  ref={this.fileInput}>Choose File</button><span>{this.state.file ? this.state.file : 'No file selected'}</span>
                {this.state.invalidMessage.length > 0 &&
                  <span className='usa-input-error-message' id='file-error' role='alert'>{this.state.invalidMessage.map(m => m + '\n')}</span>}
              </div>
            </fieldset>
            <LgyFormSubmit
              pristine={!this.state.file}
              submitting={uploader.state === 2}
              percent={uploader.state === 2 ? uploader.total.percent : undefined}
              submitFailed={uploader.error || this.state.responseMessage === 'N'}
              submitSucceeded={this.state.responseMessage === 'Y'}
              invalid={this.state.invalidMessage.length > 0}
              reset={this.handleReset} />
          </form>
        </LgySubsection>
        <DocumentsUploadHistory correspondence={correspondence} username={portalId} eauthUrl={eauthUrl} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  uploader: state.appraiser.assignments.appraiserUploads.otherCorrespondence,
  correspondence: state.appraiser.assignments.assignmentCorrespondence.allCorrespondence ? state.appraiser.assignments.assignmentCorrespondence.allCorrespondence : [],
  eauthUrl: state.serverProperties.eauthUrl,
  portalId: state.currentUser.portalId
})

const mapDispatchToProps = { uploaderInit, removeFile, startUpload, setOption, destroy, fetchAssignmentCorrespondence }

export default connect(mapStateToProps, mapDispatchToProps)(CorrespondenceHistory)
